module.exports = __webpack_public_path__ + "static/img/6.324ca3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/6.png
// module id = btyd
// module chunks = 0